module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("“If you give me time, I’ll make my fortune.”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1_1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Jay Gould")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("“I shall be rich.”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1_1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Jay Cooke")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("“I’m bound to be rich! BOUND TO BE RICH!”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1_1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("John D. Rockefeller")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("“Oh, I’m rich! I’m rich!”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1_1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Andrew Carnegie")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0